import { render } from "./LoginPopup.vue?vue&type=template&id=4479a3ce"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__